// extracted by mini-css-extract-plugin
export default {"Terms":"Terms_Terms__firqn","Title":"Terms_Title__kfTO+","ListTitles":"Terms_ListTitles__tpwhd","AccordianLists":"Terms_AccordianLists__Fsvir"};